if (!customElements.get("m-slideshow")) {
  class t extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = "true" === this.dataset.autoplay;
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = "true" === this.dataset.enableArrows;
      this.showDots = "true" === this.dataset.enableDots;
      this.adaptHeight = "adapt" === this.dataset.slideHeight;
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");
      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this.initSlider();
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: !!this.autoplay && {
          delay: 1000 * this.autoplaySpeed,
          disableOnInteraction: true
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        speed: 1000,

        navigation: !!this.showArrows && {
          nextEl: this.querySelector(".m-slider-controls__button-next"),
          prevEl: this.querySelector(".m-slider-controls__button-prev")
        },

        pagination: !!this.showDots && {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
          bulletClass: "m-dot",
          bulletActiveClass: "m-dot--active",
          renderBullet: function(index, className) {
            return `<span class="${className}" data-index="${index}"></span>`;
          }
        },

        breakpoints: {
          992: {
            threshold: 2
          }
        }
      });

      this.lastSlide = null;
      this.currentSlide = null;

      if (this.slider) {
        this.slider.on("init", this.handleChange.bind(this));
      }

      if (this.slider) {
        this.slider.on("slideChange", this.handleChange.bind(this));
      }

      this.slider.init();

      document.addEventListener(
        "shopify:block:select",
        (t) => this.onBlockSelect(t)
      );
    }

    handleChange(t) {
      const { activeIndex, slides } = t;
      const slideType =
        slides[activeIndex] && slides[activeIndex].dataset.slideType;

      if (this.lastActive) {
        this.slider.slideToLoop(this.lastActive);
      }

      if ("video_slide" === slideType) {
        const video =
          slides[activeIndex] &&
          slides[activeIndex].querySelector("video");

        if (video) {
          let playPromise = video.play();

          if (this.lastVideo) {
            this.lastVideo.pause();
          }

          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            });
          }
        }
      } else {
        if (this.lastVideo) {
          this.lastVideo.pause();
        }
        this.lastVideo = null;
      }
    }

    onBlockSelect(t) {
      const block = t.target;
      const slideIndex = Number(block.dataset.slide);

      this.lastActive = slideIndex;

      if (this.slider) {
        this.slider.slideToLoop(slideIndex);
      }
    }
  }

  customElements.define("m-slideshow", t);
}